'use strict';

import { TYPES } from "../../../hooks/useSearchFilters";

export default function Checkbox({
    type = [TYPES.CHECKBOX, TYPES.RADIO][0],
    id = undefined,
    title = '',
    count = undefined,
    price = undefined,
    currency = undefined,
    isChecked,
    isDisabled = false,
    onChange
}) {

    const inputId = React.useId()

    const handleChange = (value) => {
        onChange && onChange(value)
    }
    
    const handleClick = (value) => {
        if (type !== TYPES.RADIO) return;
        if (!isChecked) return;
        if (!value) return;
        onChange && onChange(false)
    }

    return <div className="checkbox2">
        <input id={id || inputId}
               type={type}
               checked={isChecked}
               disabled={isDisabled}
               onChange={(e) => handleChange(e.currentTarget.checked)}
               onClick={(e) => handleClick(e.currentTarget.checked)}
        />
        <label htmlFor={id || inputId}>
            {title && <div style={{textOverflow: 'clip', overflow: 'hidden'}} title={title}>{title}</div>}
            {count !== null && <i>{`(${count})`}</i>}
            {price > 0 && price !== Infinity && <span>{price.formatPrice(currency)}</span>}
        </label>
    </div>
}